import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const BlockchainServiceContext = createContext(null);
export const BlockchainServiceProvider = ({ children, blockchainService }) => {
    return (_jsx(BlockchainServiceContext.Provider, { value: { blockchainService }, children: children }));
};
//# sourceMappingURL=blockchain-service.js.map